module.exports = __webpack_public_path__ + "img/bl2fl01_center_001.c38c3317.png";